<header id="page-topbar">
  <div class="navbar-header">
    <!-- Left Section: Logo, Menu Toggle, Service Center Selector, Search -->
    <div class="d-flex flex-grow-1">
      <!-- Logo -->
    <div class="navbar-brand-box header-item">
      <a routerLink="/" class="logo logo-light">
        <span class="logo-sm"></span>
        <span class="d-flex justify-content-center align-items-center logo-lg">
          <img [src]="logoURL" alt="Company Logo" class="navbar-header">
        </span>
      </a>
    </div>

      <!-- Mobile Menu Toggle Button -->
      <button type="button" class="btn btn-sm px-3 font-size-16 header-item" id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>

      <!-- Service Center Selector -->
      <div class="col-md-2 mt-2">
        <select class="form-select" (change)="onServiceCenterChange($event)" [(ngModel)]="selectedSCId"
          [disabled]="isEditMode">
          <ng-container *ngIf="!serviceCenters || serviceCenters?.length === 0">
            <option>Select Service Center</option>
          </ng-container>
          <option *ngFor="let sc of serviceCenters" [value]="sc.id">
            {{ sc.name }}
          </option>
        </select>
      </div>

      <!-- AWB Search Form (Desktop) -->
      <form class="col-md-3 mt-1 awb-search-form" *ngIf="showSearch" (submit)="search(awbInput)">
        <div class="input-group" style="max-width: 280px;">
          <span class="input-group-text p-0 px-2 bg-light border-end-0">
            <i class="mdi mdi-map-marker-radius font-size-16" style="color: #12406e"></i>
          </span>
          <input type="search" class="form-control form-control-sm border-start-0" placeholder="Track AWB here..."
            #awbInput />
          <button type="submit" class="btn btn-primary btn-sm d-flex align-items-center">
            <i class="bx bx-search font-size-16"></i>
          </button>
        </div>
      </form>

      <!-- Credit Control Panel - Compact Theme Design -->
      <div class="ms-auto d-flex align-items-center" *ngIf="this.userData.accessType === 'Customer'">
        <div class="credit-control-panel d-flex align-items-center gap-2 px-2 py-1 rounded-3" id="btnGroupBalance"
          style="height: 32px; background-color: #f7f7fa;">

          <!-- Limit Badge -->
          <div class="credit-badge d-flex align-items-center gap-1"
            (mouseenter)="showTooltip($event, 'Limit: ' + creditDetails.limit)" (mouseleave)="hideTooltip($event)"
            style="cursor: pointer;">
            <div class="badge-icon rounded-circle d-flex align-items-center justify-content-center"
              style="width: 20px; height: 20px; background-color: #f1b44c;">
              <i class="mdi mdi-arrow-up-bold text-white" style="font-size: 10px;"></i>
            </div>
            <div class="badge-content d-flex align-items-center gap-1">
              <span class="badge-label" style="font-size: 10px; color: #6c757d;">Limit:</span>
              <span class="badge-value fw-semibold" style="font-size: 11px; color: #25476a;">
                {{ creditDetails.limit }}
              </span>
            </div>
          </div>

          <div class="vr" style="height: 16px; opacity: 0.2;"></div>

          <!-- Used Badge -->
          <div class="credit-badge d-flex align-items-center gap-1"
            (mouseenter)="showTooltip($event, 'Used: ' + creditDetails.used)" (mouseleave)="hideTooltip($event)"
            style="cursor: pointer;">
            <div class="badge-icon rounded-circle d-flex align-items-center justify-content-center"
              style="width: 20px; height: 20px; background-color: #f49899;">
              <i class="mdi mdi-minus text-white" style="font-size: 10px;"></i>
            </div>
            <div class="badge-content d-flex align-items-center gap-1">
              <span class="badge-label" style="font-size: 10px; color: #6c757d;">Used:</span>
              <span class="badge-value fw-semibold" style="font-size: 11px; color: #3a5f85;">
                {{ creditDetails.used }}
              </span>
            </div>
          </div>

          <div class="vr" style="height: 16px; opacity: 0.2;"></div>

          <!-- Balance Badge -->
          <div class="credit-badge d-flex align-items-center gap-1"
            (mouseenter)="showTooltip($event, 'Balance: ' + creditDetails.balance)" (mouseleave)="hideTooltip($event)"
            style="cursor: pointer;">
            <div class="badge-icon rounded-circle d-flex align-items-center justify-content-center"
              style="width: 20px; height: 20px; background-color: #81cd9a;">
              <i class="mdi mdi-wallet-outline text-white" style="font-size: 10px;"></i>
            </div>
            <div class="badge-content d-flex align-items-center gap-1">
              <span class="badge-label" style="font-size: 10px; color: #6c757d;">Balance:</span>
              <span class="badge-value fw-semibold" style="font-size: 11px; color: #1a3651;">
                {{ creditDetails.balance }}
              </span>
            </div>
          </div>

        </div>
      </div>

      <!-- Custom Tooltip -->
      <div class="tooltip" *ngIf="tooltipVisible" [style.top.px]="tooltipY" [style.left.px]="tooltipX">
        {{ tooltipText }}
      </div>
    </div>

    <!-- Shortcuts Information Icon -->
    <span *ngIf="shortcutsInstructions" style="cursor: pointer;" ngbTooltip="Shortcuts" placement="bottom"
      container="body" title="Shortcuts" (click)="openShortcutModal(shortcutModal)">
      <i class="mdi mdi-information-outline me-1 font-size-20"></i>
    </span>

    <!-- Shortcut Modal Template -->
    <ng-template #shortcutModal let-modal>
      <div class="modal-header">
        <h5 class="modal-title">{{ shortcutModalTitle }}</h5>
        <button type="button" class="btn-close" (click)="modal.dismiss()" aria-label="Close"></button>
      </div>
      <div class="modal-body" [innerHTML]="shortcutsInstructions"></div>
    </ng-template>

    <!-- Right Section: Search, Language, Fullscreen, Profile -->
    <div class="d-flex">
      <!-- Mobile Search Dropdown -->
      <div class="dropdown d-inline-block d-lg-none ms-2" ngbDropdown #searchDropdown="ngbDropdown" *ngIf="showSearch">
        <button type="button" class="btn header-item noti-icon" id="page-header-search-dropdown" data-toggle="dropdown"
          aria-haspopup="true" ngbDropdownToggle aria-expanded="false">
          <i class="mdi mdi-magnify"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" ngbDropdownMenu
          aria-labelledby="page-header-search-dropdown">
          <form class="p-3" (submit)="searchMobile($event, mobileAwbInput, searchDropdown)">
            <div class="m-0">
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Track AWB here..." aria-label="Track AWB here..."
                  #mobileAwbInput>
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- Language Selector Dropdown -->
      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item" id="page-header-user-dropdown" ngbDropdownToggle>
          <img *ngIf="flagvalue !== undefined" [src]="flagvalue" alt="Header Language" height="16">
          <span class="ms-1">{{ countryName }}</span>
          <img *ngIf="flagvalue === undefined" [src]="valueset" alt="Header Language" height="16">
          <span *ngIf="flagvalue === undefined" class="ms-1">English</span>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <a href="javascript:void(0);" class="dropdown-item notify-item" *ngFor="let item of listLang"
            (click)="setLanguage(item.text, item.lang, item.flag)" [ngClass]="{'active': cookieValue === item.lang}">
            <img [src]="item.flag" alt="user-image" class="me-1" height="16" width="18">
            <span class="align-middle">{{ item.text }}</span>
          </a>
        </div>
      </div>

      <!-- Fullscreen Toggle Button -->
      <div class="dropdown d-none d-lg-inline-block ms-1">
        <button type="button" class="btn header-item noti-icon" data-toggle="fullscreen" (click)="fullscreen()">
          <i class="bx bx-fullscreen"></i>
        </button>
      </div>

      <!-- User Profile Dropdown -->
      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item" ngbDropdownToggle id="page-header-user-dropdown">
          <img class="rounded-circle header-profile-user" [src]="profileImageUrl" alt="Header Avatar">
          <span class="d-none d-xl-inline-block ms-1">{{ userData.userName }}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <!-- User Info Header -->
          <div class="dropdown-header noti-title">
            <h5 class="font-size-13 text-muted text-truncate mn-0">
              Login Type: <b>{{ loggedInAs }}</b>
            </h5>
            <p style="margin: 0;">{{ userData?.emailId }}</p>
          </div>
          <div class="dropdown-divider"></div>

          <!-- Profile Link -->
          <a class="dropdown-item" routerLink="/profile">
            <i class="bx bx-user font-size-16 align-middle me-1"></i>
            {{ 'HEADER.LOGIN.PROFILE' | translate }}
          </a>

          <!-- Settings Link (Client Only) -->
          <a *ngIf="loggedInAs === 'Client'" class="dropdown-item d-block" href="/settings">
            <i class="bx bx-wrench font-size-16 align-middle me-1"></i>
            {{ 'HEADER.LOGIN.SETTINGS' | translate }}
          </a>

          <!-- Help Link -->
          <a class="dropdown-item d-block" href="/help">
            <i class="bx bx-help-circle font-size-16 align-middle me-1"></i>
            {{ 'HEADER.LOGIN.HELP' | translate }}
          </a>

          <div class="dropdown-divider"></div>

          <!-- Logout Link -->
          <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()">
            <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            {{ 'HEADER.LOGIN.LOGOUT' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</header>